import { getIconProps, type IconProps } from '#types'

/**
 * Monitor icon — a screen on a stand.
 *
 * The bay computer: the Bay PIN step on the access pages and the Bay PIN in the Access Codes
 * card. Product's "Icon set/PC" (Figma `15852:133132`), drawn on its own 54-unit grid as a
 * filled outline, so it takes no `strokeWidth`.
 *
 * @example
 * ```tsx
 * <MonitorIcon className="size-10 text-white" />
 * ```
 */
export function MonitorIcon(props: IconProps) {
  return (
    <svg {...getIconProps(props)} viewBox="0 0 54 54">
      <path
        d="M18 43.75C17.3096 43.75 16.75 44.3096 16.75 45C16.75 45.6904 17.3096 46.25 18 46.25V45V43.75ZM36 46.25C36.6904 46.25 37.25 45.6904 37.25 45C37.25 44.3096 36.6904 43.75 36 43.75V45V46.25ZM47.25 11H46V34H47.25H48.5V11H47.25ZM6.75 34H8V11H6.75H5.5V34H6.75ZM45.25 9V7.75H8.75V9V10.25H45.25V9ZM45.25 36V34.75H8.75V36V37.25H45.25V36ZM18 45V46.25H27V45V43.75H18V45ZM27 45V46.25H36V45V43.75H27V45ZM27 45H28.25V36H27H25.75V45H27ZM6.75 11H8C8 10.5858 8.33579 10.25 8.75 10.25V9V7.75C6.95507 7.75 5.5 9.20508 5.5 11H6.75ZM6.75 34H5.5C5.5 35.7949 6.95507 37.25 8.75 37.25V36V34.75C8.33579 34.75 8 34.4142 8 34H6.75ZM47.25 34H46C46 34.4142 45.6642 34.75 45.25 34.75V36V37.25C47.0449 37.25 48.5 35.7949 48.5 34H47.25ZM47.25 11H48.5C48.5 9.20507 47.0449 7.75 45.25 7.75V9V10.25C45.6642 10.25 46 10.5858 46 11H47.25Z"
        fill="currentColor"
      />
    </svg>
  )
}
